import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'

const initialState: RouteInfo = {
  titleId: '',
  path: '',
  currentUri: '',
  previousUri: '',
}

const slice = createSlice({
  name: 'routeInfo',
  initialState,
  reducers: {
    updateRoute: (state, action) => {
      state.titleId = action.payload.titleId
      state.path = action.payload.path
      state.previousUri = state.currentUri
      state.currentUri = action.payload.uri
    },
  },
})

export const { updateRoute } = slice.actions

export const selectRoute = (state: RootState): RouteInfo => state.route

export default slice.reducer
